import React, { useMemo, useState } from 'react'
import { SingleSpecCategoryList } from '@/pages/products/components/specification/SingleSpecCategoryList'
import { Fields } from '@hako/core'

export const SpecList = ({ items }) => {
    const [isAllVisible, setIsAllVisible] = useState(false)

    const itemsArray = Object.entries(items)
    const firstElement = itemsArray[0]
    const restElements = useMemo(() => {
        return itemsArray.slice(1)
    }, [itemsArray.length])

    return (
        <>
            <SingleSpecCategoryList category={firstElement} />
            {isAllVisible &&
                restElements.map((element, index) => (
                    <SingleSpecCategoryList key={index} category={element} />
                ))}
            <div className="table__btn u-flex-row u-justify-content-center">
                <button
                    onClick={() => setIsAllVisible((prevState) => !prevState)}
                    className="btn btn--primary btn--dark u-margin-top-medium"
                >
                    {isAllVisible ? (
                        <Fields.Text
                            editable={false}
                            key={isAllVisible}
                            as="span"
                            scope="global"
                            slug="show-less-list"
                        >
                            Show less
                        </Fields.Text>
                    ) : (
                        <Fields.Text
                            editable={false}
                            key={isAllVisible}
                            as="span"
                            scope="global"
                            slug="see-full-list"
                        >
                            See full list
                        </Fields.Text>
                    )}
                </button>
            </div>
        </>
    )
}
